import { render, staticRenderFns } from "./MedicalInsInvoice.vue?vue&type=template&id=8877fe1a&"
import script from "./MedicalInsInvoice.vue?vue&type=script&lang=ts&"
export * from "./MedicalInsInvoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports